<template>
  <div class="transaction-table">
    <div class="transaction" v-for="transaction of section.data" :key="transaction.transactionId">
      <div class="date">{{ formatDate(transaction.transactionDate) }}</div>
      <div class="name">{{ transaction.businessName }}</div>
      <div class="amount">{{ formatAmount(transaction.amount || transaction.billingAmount) }} ₪</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import moneyUtils from '../money';

export default {
  name: 'TransactionTable',
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatAmount(amount) {
      return moneyUtils.formatAmountWithFraction(amount, 0);
    },
    openLink(url) {
      this.$emit('link-clicked', url);
    },
    formatDate(transactionDate) {
      return moment(transactionDate).format('D/M/YY');
    },
  },
};

</script>

<style lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/spacings.scss';
.transaction-table {
  margin: 16px 0;
  max-height: 260px;
  overflow: scroll;

  .transaction {
    padding: $ri-spacing-sm $ri-spacing-s;
    display: flex;
    align-items: center;
    background-color: $riseup_gray_disabled;
    border-bottom: 1px solid $riseup_gray_0;
    &:last-child {
      border-bottom: none;
    }
    font-size: 12px;

    .date {
      width: 60px;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .name {
      flex-grow: 1;
      padding-left: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .amount {
      width: 60px;
      flex-shrink: 0;
    }
  }
}
</style>
